export function explorerTxUrl(sig: string): string {
  const cluster = (import.meta.env.VITE_SOLANA_CLUSTER as string | undefined) ?? "";
  const rpc =
    (import.meta.env.VITE_SOLANA_RPC as string | undefined) ??
    "http://127.0.0.1:8899";
  if (cluster === "mainnet" || cluster === "mainnet-beta") {
    return `https://explorer.solana.com/tx/${sig}`;
  }
  if (cluster === "devnet") {
    return `https://explorer.solana.com/tx/${sig}?cluster=devnet`;
  }
  if (cluster === "testnet") {
    return `https://explorer.solana.com/tx/${sig}?cluster=testnet`;
  }
  return `https://explorer.solana.com/tx/${sig}?cluster=custom&customUrl=${encodeURIComponent(rpc)}`;
}
